const defaultPath = "questions";


export const questionsRouters = [
  {
    name: `QuestionsHome`,
    path: `/${defaultPath}`,
    component: () => import(`../../views/${defaultPath}/List.vue`),
  },
  {
    name: `QuestionsCreate`,
    path: `/${defaultPath}/create`,
    component: () => import(`../../views/${defaultPath}/Create.vue`),
  },
  {
    name: `QuestionsUpdate`,
    path: `/${defaultPath}/:id/edit`,
    component: () => import(`../../views/${defaultPath}/Update.vue`),
  },
  {
    name: `QuestionsDetail`,
    path: `/${defaultPath}/:id`,
    component: () => import(`../../views/${defaultPath}/Detail.vue`),
  },
  {
    name: `QuestionsList`,
    path: `/${defaultPath}/list`,
    component: () => import(`../../views/${defaultPath}/List.vue`),
  },
  {
    name: `QuestionsPages`,
    path: `/${defaultPath}/pages/:sinifId/:dersId/:uniteId`,
    component: () => import(`../../views/${defaultPath}/Pages.vue`),
  },
  {
    name: `QuestionsPagesId`,
    path: `/${defaultPath}/pages/:sinifId/:dersId/:uniteId/:pageId/:subpageId?`,
    component: () => import(`../../views/${defaultPath}/PagesA4Print.vue`),
  },
  {
    name: `QuestionsPagesPreview`,
    path: `/${defaultPath}/pages/:sinifId/:dersId/:uniteId/preview`,
    component: () => import(`../../views/${defaultPath}/PagesPreview.vue`),
  },
];
